(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      return window.Currency.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }

  function sameOptions(first, second) {
    if (!first || !second || first.length !== second.length) return false;
    return first.every(function (value, index) {
      return String(value).toLowerCase() === String(second[index]).toLowerCase();
    });
  }

  function currentVariant(root, data) {
    var section = root.closest('[data-section-type="product"]');
    var input = section && section.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input ? String(input.value) : '';
    return data.currentVariants.find(function (variant) { return String(variant.id) === id; }) || data.currentVariants[0];
  }

  function matchingVariant(product, referenceVariant) {
    if (!product || !product.variants || !product.variants.length) return null;
    var match = product.variants.find(function (variant) {
      return variant.available && referenceVariant && sameOptions(variant.options, referenceVariant.options);
    });
    if (!match && referenceVariant) {
      match = product.variants.find(function (variant) {
        return variant.available && variant.title === referenceVariant.title;
      });
    }
    if (!match && product.variants.length === 1 && product.variants[0].available) match = product.variants[0];
    return match || null;
  }

  function selectBundleTab(root, name) {
    if (!root) return;
    root.querySelectorAll('[data-product-bundle-tab]').forEach(function (tab) {
      var active = tab.dataset.productBundleTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-product-bundle-panel]').forEach(function (panel) {
      if (panel.dataset.productBundlePanel === name) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });
    var productSection = root.closest('[data-section-type="product"]');
    if (productSection) productSection.classList.toggle('is-product-bundle-mode', name === 'bundle');
  }

  function initialize(root) {
    if (!root || root.dataset.bundleInitialized === 'true') return;
    var builder = root.querySelector('[data-product-bundle-builder]');
    var json = root.querySelector('[data-product-bundle-data]');
    if (!builder || !json) return;

    var data;
    try { data = JSON.parse(json.textContent); } catch (error) {
      builder.innerHTML = '<p class="ProductBundleBuilder__Error">Bundle options could not be loaded. Please refresh the page.</p>';
      return;
    }
    root.dataset.bundleInitialized = 'true';

    var tiers = builder.querySelectorAll('[data-bundle-tier]');
    var slotsElement = builder.querySelector('[data-bundle-slots]');
    var addButton = builder.querySelector('[data-bundle-add]');
    var summary = builder.querySelector('[data-bundle-summary]');
    var errorElement = builder.querySelector('[data-bundle-error]');
    var sizeNote = builder.querySelector('[data-bundle-size-note]');
    var optionsElement = builder.querySelector('[data-bundle-options]');
    var quantityLabel = builder.querySelector('[data-bundle-quantity-label]');
    var addOriginalPrice = builder.querySelector('[data-bundle-add-original]');
    var addPrice = builder.querySelector('[data-bundle-add-price]');
    var productSection = root.closest('[data-section-type="product"]');
    var quantity = 2;
    var discount = 0;
    var selections = [];
    var referenceVariant = currentVariant(root, data);
    var selectedOptions = referenceVariant && referenceVariant.options ? referenceVariant.options.slice() : [];
    var bundleOptionIndexes = (data.currentOptions || []).reduce(function (indexes, name, index) {
      var normalizedName = String(name).toLowerCase().replace(/[^a-z]/g, '');
      if (normalizedName !== 'title' && normalizedName !== 'color' && normalizedName !== 'colour') {
        indexes.push(index);
      }
      return indexes;
    }, []);

    function findReferenceVariant() {
      return data.currentVariants.find(function (variant) {
        return variant.available && sameOptions(variant.options, selectedOptions);
      }) || referenceVariant || data.currentVariants[0];
    }

    function renderTierPrices() {
      referenceVariant = findReferenceVariant();
      if (!referenceVariant) return;
      var basePrice = referenceVariant.price;
      var freeShippingTier = parseInt(builder.dataset.bundleFreeShippingTier, 10);
      var bestTier = builder.dataset.bundleBestTier;
      var freeShippingLabel = builder.dataset.bundleFreeShippingLabel || 'Free shipping';
      var standardShippingLabel = builder.dataset.bundleStandardShippingLabel || '';

      tiers.forEach(function (tier) {
        var tierQuantity = parseInt(tier.dataset.bundleTier, 10) || 1;
        var tierDiscount = parseInt(tier.dataset.bundleDiscount, 10) || 0;
        var regularTotal = basePrice * tierQuantity;
        var discountedTotal = Math.round(regularTotal * (100 - tierDiscount) / 100);
        var perItem = Math.round(discountedTotal / tierQuantity);
        var savings = regularTotal - discountedTotal;
        tier.classList.toggle('is-best', bestTier === String(tierQuantity));
        tier.querySelector('[data-bundle-tier-price]').textContent = formatMoney(perItem);
        tier.querySelector('[data-bundle-tier-save]').textContent = 'Save ' + formatMoney(savings);
        tier.querySelector('[data-bundle-tier-total]').textContent = formatMoney(discountedTotal) + ' total';
        var shipping = tier.querySelector('[data-bundle-tier-shipping]');
        var shippingText = freeShippingTier && tierQuantity >= freeShippingTier ? freeShippingLabel : standardShippingLabel;
        shipping.textContent = shippingText;
        shipping.hidden = !shippingText;
      });
    }

    function renderAddButtonPrice(subtotal) {
      var total = Math.round(subtotal * (100 - discount) / 100);
      addOriginalPrice.textContent = formatMoney(subtotal);
      addOriginalPrice.hidden = discount <= 0;
      addPrice.textContent = formatMoney(total);
    }

    function renderOptionSelectors() {
      if (!optionsElement) return;
      optionsElement.innerHTML = '';
      if (!bundleOptionIndexes.length) {
        optionsElement.hidden = true;
        return;
      }

      bundleOptionIndexes.forEach(function (optionIndex) {
        var optionName = data.currentOptions[optionIndex];
        var optionElement = document.createElement('div');
        var optionLabel = document.createElement('span');
        var optionValues = document.createElement('div');
        var values = [];

        optionElement.className = 'ProductBundleBuilder__Option';
        optionLabel.className = 'ProductBundleBuilder__OptionLabel';
        optionLabel.textContent = optionName;
        optionValues.className = 'ProductBundleBuilder__OptionValues';

        data.currentVariants.forEach(function (variant) {
          var value = variant.options && variant.options[optionIndex];
          if (value && values.indexOf(value) === -1) values.push(value);
        });

        values.forEach(function (value) {
          var available = data.currentVariants.some(function (variant) {
            if (!variant.available || !variant.options || variant.options[optionIndex] !== value) return false;
            return variant.options.every(function (optionValue, index) {
              return index === optionIndex || !selectedOptions[index] || optionValue === selectedOptions[index];
            });
          });
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'ProductBundleBuilder__OptionValue' + (selectedOptions[optionIndex] === value ? ' is-selected' : '');
          button.textContent = value;
          button.disabled = !available;
          button.setAttribute('aria-pressed', selectedOptions[optionIndex] === value ? 'true' : 'false');
          button.addEventListener('click', function () {
            selectedOptions[optionIndex] = value;
            referenceVariant = findReferenceVariant();
            renderOptionSelectors();
            renderTierPrices();
            renderSlots();
          });
          optionValues.appendChild(button);
        });

        optionElement.appendChild(optionLabel);
        optionElement.appendChild(optionValues);
        optionsElement.appendChild(optionElement);
      });
      optionsElement.hidden = false;
    }

    function selectedOptionDescription(reference) {
      if (!reference || !reference.options) return '';
      return bundleOptionIndexes.map(function (optionIndex) {
        var optionName = data.currentOptions[optionIndex];
        var optionValue = reference.options[optionIndex];
        var normalizedName = String(optionName).toLowerCase().replace(/[^a-z]/g, '');
        return normalizedName.indexOf('lugwidth') !== -1 ? optionValue + ' lug width' : optionName + ': ' + optionValue;
      }).join(', ');
    }

    function availableProducts() {
      var reference = referenceVariant || findReferenceVariant();
      if (sizeNote) {
        var optionDescription = selectedOptionDescription(reference);
        sizeNote.textContent = optionDescription ? 'Selected: ' + optionDescription + '. Choose colors below.' : 'Choose a color for each item.';
      }
      return data.products.map(function (product) {
        return { product: product, variant: matchingVariant(product, reference) };
      });
    }

    function renderSummary() {
      var selected = selections.slice(0, quantity).filter(Boolean);
      var estimatedSubtotal = referenceVariant ? referenceVariant.price * quantity : 0;
      if (quantityLabel) quantityLabel.textContent = quantity + (quantity === 1 ? ' item' : ' items');
      if (selected.length !== quantity) {
        summary.textContent = 'Select ' + (quantity - selected.length) + ' more ' + ((quantity - selected.length) === 1 ? 'color' : 'colors') + '.';
        renderAddButtonPrice(estimatedSubtotal);
        addButton.disabled = true;
        return;
      }
      var subtotal = selected.reduce(function (total, item) { return total + item.variant.price; }, 0);
      summary.textContent = '';
      renderAddButtonPrice(subtotal);
      addButton.disabled = false;
    }

    function selectColor(slotIndex, item, button) {
      selections[slotIndex] = item;
      var slot = button.closest('[data-bundle-slot]');
      slot.querySelectorAll('[data-bundle-color]').forEach(function (color) { color.classList.remove('is-selected'); });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      slot.querySelectorAll('[data-bundle-color]:not(.is-selected)').forEach(function (color) { color.setAttribute('aria-pressed', 'false'); });
      slot.querySelector('[data-bundle-selected-label]').textContent = item.product.label;
      renderSummary();
    }

    function renderSlots() {
      var products = availableProducts();
      selections = selections.slice(0, quantity).map(function (selection) {
        if (!selection) return null;
        return products.find(function (item) { return String(item.product.id) === String(selection.product.id) && item.variant; }) || null;
      });
      slotsElement.innerHTML = '';

      for (var index = 0; index < quantity; index += 1) {
        var slot = document.createElement('div');
        slot.className = 'ProductBundleBuilder__Slot';
        slot.dataset.bundleSlot = String(index);
        slot.innerHTML = '<div class="ProductBundleBuilder__SlotHeader"><span class="ProductBundleBuilder__SlotNumber">Item ' + (index + 1) + '</span><span class="ProductBundleBuilder__SelectedLabel" data-bundle-selected-label>' + (selections[index] ? selections[index].product.label : 'Select color') + '</span></div><div class="ProductBundleBuilder__Colors"></div>';
        var colors = slot.querySelector('.ProductBundleBuilder__Colors');

        products.forEach(function (item) {
          var button = document.createElement('button');
          var selected = selections[index] && String(selections[index].product.id) === String(item.product.id);
          button.type = 'button';
          button.className = 'ProductBundleBuilder__Color' + (selected ? ' is-selected' : '');
          button.dataset.bundleColor = String(item.product.id);
          button.disabled = !item.variant;
          button.setAttribute('aria-label', item.product.label + (item.variant ? '' : ' - unavailable in this size'));
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          button.title = item.product.label;
          button.innerHTML = item.product.image ? '<img src="' + item.product.image + '" alt="" width="55" height="69" loading="lazy">' : '<span class="ProductBundleBuilder__ColorInitials">' + item.product.label.slice(0, 2).toUpperCase() + '</span>';
          if (item.variant) {
            button.addEventListener('click', function () {
              var selectedSlot = button.closest('[data-bundle-slot]');
              selectColor(parseInt(selectedSlot.dataset.bundleSlot, 10), item, button);
            });
          }
          colors.appendChild(button);
        });
        slotsElement.appendChild(slot);
      }
      renderSummary();
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        quantity = parseInt(tier.dataset.bundleTier, 10);
        discount = parseInt(tier.dataset.bundleDiscount, 10) || 0;
        tiers.forEach(function (item) {
          var selected = item === tier;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });
        renderSlots();
      });
      if (tier.classList.contains('is-selected')) {
        discount = parseInt(tier.dataset.bundleDiscount, 10) || 0;
        tier.tabIndex = 0;
      } else {
        tier.tabIndex = -1;
      }
    });

    addButton.addEventListener('click', function () {
      var selected = selections.slice(0, quantity).filter(Boolean);
      if (selected.length !== quantity) return;
      addButton.disabled = true;
      errorElement.hidden = true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: selected.map(function (item) { return { id: String(item.variant.id), quantity: 1 }; }) })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || body.message || 'Unable to add this bundle.'); });
        return response.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: selected[0].variant, quantity: quantity }
        }));
        selections = [];
        renderSlots();
      }).catch(function (error) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        errorElement.textContent = error.message;
        errorElement.hidden = false;
        addButton.disabled = false;
      });
    });

    if (productSection) {
      productSection.addEventListener('change', function (event) {
        if (event.target.closest('.ProductForm__Option')) {
          window.setTimeout(function () {
            referenceVariant = currentVariant(root, data);
            selectedOptions = referenceVariant && referenceVariant.options ? referenceVariant.options.slice() : [];
            renderOptionSelectors();
            renderTierPrices();
            renderSlots();
          }, 0);
        }
      });
    }
    renderOptionSelectors();
    renderTierPrices();
    renderSlots();
  }

  function initializeAll(container) {
    (container || document).querySelectorAll('[data-product-bundle-tabs]').forEach(initialize);
  }

  if (!window.mavenProductBundleTabDelegationReady) {
    window.mavenProductBundleTabDelegationReady = true;
    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-product-bundle-tab]');
      if (!tab) return;
      var root = tab.closest('[data-product-bundle-tabs]');
      if (!root) return;
      event.preventDefault();
      selectBundleTab(root, tab.dataset.productBundleTab);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
